
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiElectricGeneratorAc as ObiElectricGeneratorAcElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-electric-generator-ac.js';
 
 
 

 
 export const ObiElectricGeneratorAc = createComponent({
   react: React,
   tagName: 'obi-electric-generator-ac',
   elementClass: ObiElectricGeneratorAcElement,
   events: {
     
   }
  });
 
 